import {TranslateService} from '@ngx-translate/core';

import {Scss} from '../../shared/utils/scss';
import {RequestStatus} from '../../shared/workflow/workflow-v2.interface';

export const getWorkflowByStatusChartConfig = (
  countByStatus: {[key in RequestStatus]?: number},
  workflowStatuses: {name: string, key: RequestStatus }[],
  resolvedStatusColors: {[key: string]: string},
  translate: TranslateService
) => {
  const categories = workflowStatuses.map(s => translate.instant(s.name));
  const seriesData = workflowStatuses.map(s => {
    // Ensure actual color is applied to each bar
    const barColor = resolvedStatusColors[s.key] || Scss.variable('chart-fallback'); // Fallback color
    return {
      value: countByStatus[s.key] || 0,
      itemStyle: {
        color: barColor
      },
      name: translate.instant(s.name)
    };
  });

  return {
    title: {
      text: translate.instant('PROCESS_MONITOR.process_by_status_chart_title'),
      top: '1%',
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      confine: true
    },
    grid: {
      left: '8%',
      right: '4%',
      top: '20%',
      bottom: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        interval: 0,
        rotate: 45,
        align: 'right'
      }
    },
    yAxis: {
      type: 'value',
      name:  translate.instant('PROCESS_MONITOR.processes'),
      axisLabel: {
        formatter: '{value}'
      }
    },
    series: [
      {
        name: translate.instant('PROCESS_MONITOR.processes'),
        type: 'bar',
        data: seriesData,
        barWidth: '60%',
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(180, 180, 180, 0.2)'
        }
      }
    ]
  };
};


